export const barajarCartas = (array) => {  
  const nuevoArray = [...array];  
  for (let i = nuevoArray.length - 1; i > 0; i--) {  
    const j = Math.floor(Math.random() * (i + 1));  
    [nuevoArray[i], nuevoArray[j]] = [nuevoArray[j], nuevoArray[i]];  
  }  
  return nuevoArray;  
};